import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CaseLevel1Code, CaseLevel2Code } from 'shared/constants/common-cases';

import type { CommonCasesInitialState } from './types';

const initialState: CommonCasesInitialState = {
  caseLevel1: null,
  caseLevel2: null,
  searchTerm: '',
};

const commonCasesSlice = createSlice({
  name: 'userCommonCases',
  initialState,
  reducers: {
    setCaseLevels: (
      state,
      action: PayloadAction<{
        caseLevel1: CaseLevel1Code;
        caseLevel2?: CaseLevel2Code;
      }>
    ) => {
      state.caseLevel1 = action.payload.caseLevel1;
      state.caseLevel2 = action.payload.caseLevel2 ?? null;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    reset: (state) => {
      Object.assign(state, initialState);
    },
    resetCaseLevels: (state) => {
      state.caseLevel1 = null;
      state.caseLevel2 = null;
    },
  },
});

export const { reset, resetCaseLevels, setCaseLevels, setSearchTerm } =
  commonCasesSlice.actions;
export default commonCasesSlice.reducer;
